/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListJsonWebKeySetsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListJsonWebKeySetsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListJsonWebKeySetsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListJsonWebKeySetsSecurity$outboundSchema: z.ZodMiniType<
  ListJsonWebKeySetsSecurity$Outbound,
  ListJsonWebKeySetsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listJsonWebKeySetsSecurityToJSON(
  listJsonWebKeySetsSecurity: ListJsonWebKeySetsSecurity,
): string {
  return JSON.stringify(
    ListJsonWebKeySetsSecurity$outboundSchema.parse(listJsonWebKeySetsSecurity),
  );
}

/** @internal */
export type ListJsonWebKeySetsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListJsonWebKeySetsRequest$outboundSchema: z.ZodMiniType<
  ListJsonWebKeySetsRequest$Outbound,
  ListJsonWebKeySetsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listJsonWebKeySetsRequestToJSON(
  listJsonWebKeySetsRequest: ListJsonWebKeySetsRequest,
): string {
  return JSON.stringify(
    ListJsonWebKeySetsRequest$outboundSchema.parse(listJsonWebKeySetsRequest),
  );
}
